import { templateEditorLogger } from '../logger.instance';
import type { PathExpression } from './ast-node.model';

const logger = templateEditorLogger.extend('path-expression');

/**
 * Implementação do nó `PathExpression` da AST.
 * Representa o caminho para uma variável ou função, como `context.actor.name`.
 */
export class PathExpressionNode implements PathExpression {
  public readonly type = 'PathExpression';

  /**
   * As partes do caminho divididas por `.` (ex: ['context', 'actor', 'name']).
   */
  public parts: string[];

  /**
   * Indica se é uma `@data` variable (ex: `@index`).
   */
  public data: boolean;

  /**
   * @param original A string completa do caminho (ex: 'context.actor.name').
   */
  public constructor(public original: string) {
    this.data = original.startsWith('@');
    const path = this.data ? original.slice(1) : original;
    this.parts = path.split('.');
    logger.debug('PathExpressionNode created', this);
  }

  /**
   * Converte o nó de volta para sua representação em string.
   *
   * @returns A string original do caminho.
   */
  public toString(): string {
    return this.original;
  }
}
